import { useGT } from "gt-react";
import { Sun, Moon } from "lucide-react";
import { useThemeStore } from "../store";

export function ThemeToggle() {
  const resolved = useThemeStore((s) => s.resolved);
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  const t = useGT();

  const toggle = () => {
    if (mode === "system") {
      // Switch to opposite of current resolved
      setMode(resolved === "dark" ? "light" : "dark");
    } else {
      setMode(mode === "dark" ? "light" : "dark");
    }
  };

  return (
    <button
      onClick={toggle}
      className="rounded p-1.5 text-zinc-500 hover:bg-surface-raised hover:text-zinc-300"
      title={t("Switch to {mode} mode", { mode: resolved === "dark" ? "light" : "dark" })}
    >
      {resolved === "dark" ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}
